<div class="col-xl-9">
  <div class="card">
    <div class="card-body">
      <div class="border-bottom d-flex justify-content-between">
        <h3>Update CTC</h3>
        <h4>2/4</h4>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="col-xl-6">
          <div class="my-4">
            <label for="currentCtc" class="form-label">Current CTC</label>
            <input
              appTrimInput
              id="currentCtc"
              type="text"
              class="form-control"
              [placeholder]="currentCtcValue"
              disabled
            />
          </div>
          <form [formGroup]="form">
            <div class="my-4">
              <label for="payoutFrequency" class="form-label"
                >Payout Frequency <span class="text-danger">*</span></label
              >
              <select class="form-select" id="payoutFrequency" formControlName="payoutFrequency">
                <option selected disabled value="">Select Payout Frequency</option>
                <option *ngFor="let val of payoutFrequencyValues" [ngValue]="val">
                  {{ formatEnumValues(val) }}
                </option>
              </select>
            </div>
            <div class="my-4 d-flex justify-content-between">
              <div>
                <label for="percentIncrease" class="form-label">&percnt; Increase</label>
                <input
                  appTrimInput
                  id="percentIncrease"
                  type="number"
                  class="form-control"
                  placeholder="&percnt;"
                  (input)="updateCtcAmount($event)"
                />
              </div>
              <div>
                <label for="revisedCtc" class="form-label"
                  >Revised CTC <span class="text-danger">*</span></label
                >
                <input
                  appTrimInput
                  type="number"
                  id="revisedCtc"
                  class="form-control"
                  formControlName="ctc"
                  appIndianNumberInputFormat
                />
              </div>
            </div>
            <div class="my-4">
              <label for="basis" class="form-label">Basis <span class="text-danger">*</span></label>
              <select class="form-select" id="basis" formControlName="basis">
                <option selected value="">Select Basis</option>
                <option *ngFor="let val of basisValues" [ngValue]="val">
                  {{ formatEnumValues(val) }}
                </option>
              </select>
            </div>
            <div *ngIf="this.currentMode !== salaryMode.UPDATE" class="my-4">
              <label for="effectiveFrom" class="form-label">
                Effective From <span class="text-danger">* </span>
              </label>
              <input
                appTrimInput
                id="effectiveFrom"
                type="date"
                class="form-control"
                formControlName="effectiveFrom"
                [attr.min]="minEffectiveFromDate"
              />
            </div>
            <div *ngIf="this.currentMode !== salaryMode.UPDATE" class="my-4">
              <label for="payoutFrom" class="form-label"
                >PayOut From <span class="text-danger">* </span>
                <i
                  class="ti ti-info-circle text-info"
                  ngbTooltip="PayOut can't be less then Effective From or a Pay-Roll run month"
                  placement="right"
                ></i
              ></label>
              <input
                appTrimInput
                id="payoutFrom"
                type="month"
                class="form-control"
                formControlName="payoutFrom"
                [min]="minPayOutFromMonth$ | async"
              />
              <div *ngIf="form.get('ctc')?.errors?.['required']">
                <span class="text-danger">
                  {{ getErrorMessage('ctc') }}
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
